import { Store } from "lucide-react";
import { memo, useCallback } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useWebshopFilter } from "@/contexts/WebshopFilterContext";

export const WebshopSelector = memo(function WebshopSelector() {
  const { selectedWebshopId, setSelectedWebshopId, availableWebshops, loading } = useWebshopFilter();

  const handleValueChange = useCallback((value: string) => {
    setSelectedWebshopId(value === "all" ? null : parseInt(value));
  }, [setSelectedWebshopId]);

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Store className="h-4 w-4" />
        <span>Laster...</span>
      </div>
    );
  }

  if (availableWebshops.length === 0) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Store className="h-4 w-4" />
        <span>Ingen butikker tilgjengelig</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Store className="h-4 w-4 text-muted-foreground" />
      <Select
        value={selectedWebshopId?.toString() || "all"}
        onValueChange={handleValueChange}
      >
        <SelectTrigger className="w-[250px]">
          <SelectValue placeholder="Velg butikk" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Alle butikker</SelectItem>
          {availableWebshops.map((webshop) => (
            <SelectItem key={webshop.id} value={webshop.id.toString()}>
              {webshop.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});
